import React from 'react';
import PropTypes from 'prop-types';

function CircleCheckIcon({ className = '', ...props }) {
  return (
    <svg fill='none' stroke='currentColor' viewBox='0 0 24 24' className={className} {...props}>
      <circle cx='12' cy='12' r='10' />
      <path d='m9 12 2 2 4-4' />
    </svg>
  );
}

CircleCheckIcon.propTypes = {
  className: PropTypes.string,
};

export default CircleCheckIcon;
